/* ssw-loops.js — wordless canvas background loops for SSW sections.
   Draw functions are lifted verbatim from the "Background Loops" design doc.
   Markup: <div class="ssw-loop-bg" data-ssw-loop="diamond"></div> inside a .has-loop section. */
(function () {
  var DUR = { diamond: 11, sport: 16, shoot: 14, clocks: 20, beam: 18, board: 12, circuit: 15 };

  class Loops {
    constructor() { this._build(); this.quiet = false; }
    // as a section background the HUD numerals land on real copy — drop them
    _readout(ctx, x, y, size, str, alpha, big) {
      if (this.quiet) return;
      return this._readoutRaw(ctx, x, y, size, str, alpha, big);
    }
  // ───────── geometry helpers ─────────
  _arc(cx, cy, r, a0, a1, n) {
    const p = [];
    for (let i = 0; i <= n; i++) { const a = a0 + (a1 - a0) * (i / n); p.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]); }
    return p;
  }
  _seg(a, b, n) {
    const p = [];
    for (let i = 0; i <= n; i++) { const t = i / n; p.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]); }
    return p;
  }
  _build() {
    const oval = this._arc(0, 0, 1, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2, 160).map(q => [q[0] * 1.0, q[1] * 0.54]);
    const b1 = [0.58, 0.26], b2 = [-0.58, 0.26], b3 = [0, -0.58], r = 0.27, home = [0, 0.9];
    let clover = [];
    clover = clover.concat(this._seg(home, [b1[0], b1[1] + r], 16));
    clover = clover.concat(this._arc(b1[0], b1[1], r, Math.PI / 2, Math.PI / 2 - Math.PI * 2, 54));
    clover = clover.concat(this._seg([b1[0], b1[1] + r], [b2[0], b2[1] + r], 20));
    clover = clover.concat(this._arc(b2[0], b2[1], r, Math.PI / 2, Math.PI / 2 + Math.PI * 2, 54));
    clover = clover.concat(this._seg([b2[0], b2[1] + r], [b3[0] - r, b3[1]], 18));
    clover = clover.concat(this._arc(b3[0], b3[1], r, Math.PI, Math.PI + Math.PI * 2, 54));
    clover = clover.concat(this._seg([b3[0] - r, b3[1]], home, 24));
    const d = [[0, 0.72], [0.76, 0], [0, -0.72], [-0.76, 0]];
    let diamond = [];
    for (let i = 0; i < 4; i++) diamond = diamond.concat(this._seg(d[i], d[(i + 1) % 4], 34));

    this._courses = [
      { pts: clover,  markers: [b1, b2, b3],  shape: 'barrel', cx: .60, cy: .46, s: .40, laps: 1, hue: '#FFC400' },
      { pts: oval,    markers: [0, .25, .5, .75].map(t => oval[Math.floor(t * (oval.length - 1))]), shape: 'gate', cx: .27, cy: .74, s: .19, laps: 2, hue: '#FF6A2B' },
      { pts: diamond, markers: d, shape: 'base', cx: .83, cy: .78, s: .13, laps: 1, hue: '#FFC400' }
    ];

    // shooting stage: firing positions and target array
    this._stage = {
      path: [[-0.72, 0.62], [-0.20, 0.30], [0.30, 0.52], [0.72, 0.18]],
      targets: [
        { p: [-0.60, -0.42], k: 'paper' }, { p: [-0.30, -0.62], k: 'paper' },
        { p: [0.04, -0.38], k: 'steel' },  { p: [0.34, -0.66], k: 'paper' },
        { p: [0.66, -0.34], k: 'steel' },  { p: [-0.02, -0.05], k: 'paper' }
      ],
      // shot times within the 14 s loop, and which target each hits
      shots: [[2.4, 0], [2.9, 1], [3.6, 1], [5.1, 2], [5.7, 5], [6.3, 5], [8.0, 3], [8.5, 3], [9.8, 4], [10.4, 4], [11.2, 2]]
    };
  }

  // ───────── drawing primitives ─────────
  _readoutRaw(ctx, x, y, size, value, alpha, accent) {
    ctx.font = '700 ' + size + "px 'Barlow Condensed', sans-serif";
    ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = accent
      ? 'rgba(255,196,0,' + alpha.toFixed(3) + ')'
      : 'rgba(255,255,255,' + alpha.toFixed(3) + ')';
    ctx.fillText(value, x, y);
  }
  _fit(cv) {
    const w = cv.clientWidth, h = cv.clientHeight;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    if (cv.width !== Math.round(w * dpr)) { cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); }
    const ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, w, h);
    return { ctx, w, h };
  }

  // ───────── Loop A · sports ─────────
  _drawSport(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);

    this._courses.forEach((C, ci) => {
      const cx = w * C.cx, cy = h * C.cy, sc = S * C.s;
      const P = C.pts.map(q => [cx + q[0] * sc, cy + q[1] * sc]);
      const n = P.length;
      const phase = (t * C.laps + ci * 0.18) % 1;
      const idx = Math.floor(phase * (n - 1));

      ctx.beginPath();
      P.forEach((q, i) => i ? ctx.lineTo(q[0], q[1]) : ctx.moveTo(q[0], q[1]));
      ctx.closePath();
      ctx.strokeStyle = 'rgba(255,255,255,.20)';
      ctx.lineWidth = 1.6; ctx.setLineDash([6, 8]); ctx.stroke(); ctx.setLineDash([]);

      const tail = Math.round(n * 0.26);
      ctx.lineCap = 'round';
      for (let k = 0; k < tail; k++) {
        const i = idx - k; if (i < 1) break;
        const a = 1 - k / tail;
        ctx.beginPath();
        ctx.moveTo(P[i - 1][0], P[i - 1][1]); ctx.lineTo(P[i][0], P[i][1]);
        ctx.strokeStyle = (C.hue === '#FFC400' ? 'rgba(255,196,0,' : 'rgba(255,106,43,') + (a * 0.7).toFixed(3) + ')';
        ctx.lineWidth = 1.6 + a * 3;
        ctx.stroke();
      }

      C.markers.forEach((m, mi) => {
        const x = cx + m[0] * sc, y = cy + m[1] * sc;
        const lit = phase >= (mi + 0.55) / (C.markers.length + 0.55);
        ctx.beginPath();
        if (C.shape === 'base') { ctx.save(); ctx.translate(x, y); ctx.rotate(Math.PI / 4); ctx.rect(-5, -5, 10, 10); ctx.restore(); }
        else if (C.shape === 'gate') { ctx.rect(x - 2, y - 9, 4, 18); }
        else { ctx.arc(x, y, 6.5, 0, Math.PI * 2); }
        ctx.fillStyle = lit ? 'rgba(255,196,0,.85)' : 'rgba(255,255,255,.16)';
        ctx.fill();
      });

      const R = P[idx];
      const g = ctx.createRadialGradient(R[0], R[1], 0, R[0], R[1], 26);
      g.addColorStop(0, C.hue === '#FFC400' ? 'rgba(255,196,0,.42)' : 'rgba(255,106,43,.42)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(R[0], R[1], 26, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(R[0], R[1], 5.5, 0, Math.PI * 2);
      ctx.fillStyle = C.hue; ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.85)'; ctx.lineWidth = 1.6; ctx.stroke();
    });

    // four clocks, four places on the screen
    const total = t * 16;
    const lapT = (t * 2 % 1) * 8;
    const gate = Math.floor(t * 4);
    const held = [3.42, 7.19, 10.86, 14.03][Math.min(3, gate)];
    this._readout(ctx, w * 0.10, h * 0.26, S * 0.115, total.toFixed(2), 0.20, true);
    this._readout(ctx, w * 0.62, h * 0.86, S * 0.070, lapT.toFixed(2), 0.15, false);
    this._readout(ctx, w * 0.79, h * 0.31, S * 0.052, held.toFixed(2), 0.13, false);
    this._readout(ctx, w * 0.20, h * 0.62, S * 0.044, (gate + 1) + '/4', 0.12, false);
  }

  // ───────── Loop B · shooting ─────────
  _drawShoot(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);
    const cx = w * 0.46, cy = h * 0.52, sc = S * 0.46;
    const st = this._stage;
    const secs = t * 14;
    const X = q => cx + q[0] * sc, Y = q => cy + q[1] * sc;

    // bay outline
    ctx.beginPath();
    ctx.moveTo(X([-0.92, 0]), Y([0, 0.86]));
    ctx.lineTo(X([-0.92, 0]), Y([0, -0.86]));
    ctx.lineTo(X([0.92, 0]), Y([0, -0.86]));
    ctx.lineTo(X([0.92, 0]), Y([0, 0.86]));
    ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 1.8; ctx.stroke();

    // fault line
    ctx.beginPath();
    ctx.moveTo(X([-0.92, 0]), Y([0, 0.74])); ctx.lineTo(X([0.92, 0]), Y([0, 0.74]));
    ctx.strokeStyle = 'rgba(255,196,0,.28)'; ctx.lineWidth = 1.8;
    ctx.setLineDash([9, 7]); ctx.stroke(); ctx.setLineDash([]);

    // shooter path
    ctx.beginPath();
    st.path.forEach((p, i) => i ? ctx.lineTo(X(p), Y(p)) : ctx.moveTo(X(p), Y(p)));
    ctx.strokeStyle = 'rgba(255,255,255,.22)'; ctx.lineWidth = 1.8;
    ctx.setLineDash([5, 7]); ctx.stroke(); ctx.setLineDash([]);

    // shooter position along the path
    const legs = st.path.length - 1;
    const u = Math.min(0.999, t) * legs;
    const li = Math.floor(u), lf = u - li;
    const a = st.path[li], b = st.path[Math.min(legs, li + 1)];
    const sx = X([a[0] + (b[0] - a[0]) * lf, 0]), sy = Y([0, a[1] + (b[1] - a[1]) * lf]);

    // targets, hit state
    let shotCount = 0, lastShot = 0, prevShot = 0;
    st.shots.forEach(s => { if (secs >= s[0]) { shotCount++; prevShot = lastShot; lastShot = s[0]; } });

    st.targets.forEach((tg, ti) => {
      const x = X(tg.p), y = Y(tg.p);
      const hits = st.shots.filter(s => s[1] === ti && secs >= s[0]);
      const fresh = hits.length && (secs - hits[hits.length - 1][0]) < 0.5;
      ctx.beginPath();
      if (tg.k === 'steel') {
        ctx.arc(x, y, S * 0.020, 0, Math.PI * 2);
        ctx.fillStyle = hits.length ? 'rgba(255,196,0,.55)' : 'rgba(255,255,255,.13)';
        ctx.fill();
      } else {
        const tw = S * 0.026, th = S * 0.042;
        ctx.rect(x - tw / 2, y - th / 2, tw, th);
        ctx.fillStyle = hits.length ? 'rgba(255,196,0,.52)' : 'rgba(255,255,255,.16)';
        ctx.fill();
        ctx.strokeStyle = hits.length ? 'rgba(255,196,0,.95)' : 'rgba(255,255,255,.36)';
        ctx.lineWidth = 1.4; ctx.stroke();
      }
      if (fresh) {
        const k = 1 - (secs - hits[hits.length - 1][0]) / 0.5;
        ctx.beginPath(); ctx.arc(x, y, S * 0.020 + (1 - k) * S * 0.05, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255,196,0,' + (k * 0.6).toFixed(3) + ')';
        ctx.lineWidth = 2; ctx.stroke();
      }
    });

    // muzzle flash + tracer on a fresh shot
    st.shots.forEach(s => {
      const age = secs - s[0];
      if (age < 0 || age > 0.22) return;
      const k = 1 - age / 0.22;
      const tg = st.targets[s[1]];
      ctx.beginPath();
      ctx.moveTo(sx, sy); ctx.lineTo(X(tg.p), Y(tg.p));
      ctx.strokeStyle = 'rgba(255,196,0,' + (k * 0.30).toFixed(3) + ')';
      ctx.lineWidth = 1.4; ctx.stroke();
      const g = ctx.createRadialGradient(sx, sy, 0, sx, sy, S * 0.06 * k + 6);
      g.addColorStop(0, 'rgba(255,214,120,' + (k * 0.85).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(255,106,43,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(sx, sy, S * 0.06 * k + 6, 0, Math.PI * 2); ctx.fill();
    });

    // shooter marker
    const g2 = ctx.createRadialGradient(sx, sy, 0, sx, sy, 24);
    g2.addColorStop(0, 'rgba(255,106,43,.40)'); g2.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g2; ctx.beginPath(); ctx.arc(sx, sy, 24, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(sx, sy, 6, 0, Math.PI * 2);
    ctx.fillStyle = '#FF6A2B'; ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 1.8; ctx.stroke();

    // clocks scattered across the frame
    this._readout(ctx, w * 0.71, h * 0.24, S * 0.115, secs.toFixed(2), 0.20, true);
    this._readout(ctx, w * 0.13, h * 0.82, S * 0.068, (lastShot ? (lastShot - prevShot) : 0).toFixed(2), 0.15, false);
    this._readout(ctx, w * 0.10, h * 0.28, S * 0.050, String(shotCount).padStart(2, '0'), 0.14, false);
    this._readout(ctx, w * 0.76, h * 0.79, S * 0.042, lastShot.toFixed(2), 0.12, false);
  }

  // ───────── Loop C · clocks only ─────────
  _drawClocks(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);
    const specs = [
      [0.13, 0.34, 0.150, 1.00, 0.13, true], [0.68, 0.24, 0.100, 0.62, 0.10, false],
      [0.44, 0.66, 0.072, 2.10, 0.09, false], [0.82, 0.72, 0.058, 0.34, 0.08, false],
      [0.26, 0.86, 0.048, 1.55, 0.07, false], [0.58, 0.42, 0.040, 0.85, 0.06, false]
    ];
    specs.forEach((s, i) => {
      const v = ((t * s[3] + i * 0.137) % 1) * 60;
      const drift = Math.sin(t * Math.PI * 2 + i) * S * 0.006;
      this._readout(ctx, w * s[0], h * s[1] + drift, S * s[2], v.toFixed(2), s[4], s[5]);
    });
    // a slow sweep ring behind them
    const cx = w * 0.52, cy = h * 0.5, r = S * 0.30;
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(255,255,255,.14)'; ctx.lineWidth = 2; ctx.stroke();
    const a = -Math.PI / 2 + t * Math.PI * 2;
    ctx.beginPath(); ctx.arc(cx, cy, r, -Math.PI / 2, a);
    ctx.strokeStyle = 'rgba(255,196,0,.40)'; ctx.lineWidth = 3; ctx.stroke();
    ctx.beginPath(); ctx.arc(cx + Math.cos(a) * r, cy + Math.sin(a) * r, 4, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(255,196,0,.9)'; ctx.fill();
  }

  // ───────── Loop A · home to first, 3D ─────────
  // camera sits past first base, off the line, looking back at home — the runner comes at the lens
  _cam() { return { x: 91.92, y: 8, z: 69.30, yaw: -2.093, pitch: 0.0818 }; }
  _proj(p, cam, w, h, f) {
    const dx = p[0] - cam.x, dy = p[1] - cam.y, dz = p[2] - cam.z;
    const cy = Math.cos(cam.yaw), sy = Math.sin(cam.yaw);
    const rx = dx * cy - dz * sy, rz0 = dx * sy + dz * cy;
    const cp = Math.cos(cam.pitch), sp = Math.sin(cam.pitch);
    const ry = dy * cp - rz0 * sp, rz = dy * sp + rz0 * cp;
    if (rz < 1) return null;
    return [w / 2 + f * rx / rz, h * 0.18 - f * ry / rz, rz];
  }
  _poly(ctx, pts, fill, stroke, lw) {
    if (pts.some(p => !p)) return;
    ctx.beginPath();
    pts.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
    ctx.closePath();
    if (fill) { ctx.fillStyle = fill; ctx.fill(); }
    if (stroke) { ctx.strokeStyle = stroke; ctx.lineWidth = lw || 1.4; ctx.stroke(); }
  }
  _drawDiamond(cv, t) {
    const f0 = this._fit(cv); if (!f0) return;
    const { ctx, w, h } = f0;
    const cam = this._cam(), f = w * 0.72;
    const P = p => this._proj(p, cam, w, h, f);
    const D = 90 / Math.SQRT2; // base offsets in feet
    const HOME = [0, 0, 0], B1 = [D, 0, D];

    // loop: settle, run, hold at first, reset
    const total = 11, secs = t * total;
    const t0 = 1.1, runDur = 4.05;
    const u = Math.max(0, Math.min(1, (secs - t0) / runDur));
    const running = secs > t0 && secs < t0 + runDur;
    const done = secs >= t0 + runDur;
    const fade = secs > total - 1.1 ? Math.max(0, (total - secs) / 1.1) : 1;
    // acceleration out of the box, then near-constant speed
    const ease = u < 0.34 ? (u / 0.34) * (u / 0.34) * 0.30 : 0.30 + (u - 0.34) / 0.66 * 0.70;

    // infield dirt arc + outfield grass line
    ctx.save();
    ctx.globalAlpha *= fade;   // compose with the reel's dim + cross-fade, don't clobber it
    const arc = [];
    for (let i = 0; i <= 46; i++) {
      const a = -Math.PI * 0.55 + (Math.PI * 0.75) * (i / 46);
      arc.push(P([B1[0] + Math.cos(a) * 15, 0, B1[2] + Math.sin(a) * 15]));
    }
    ctx.beginPath();
    arc.filter(Boolean).forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
    ctx.strokeStyle = 'rgba(255,255,255,.30)'; ctx.lineWidth = 2.2; ctx.stroke();

    // grass line running away behind the bag
    const fen = [];
    for (let i = 0; i <= 40; i++) {
      const s = -60 + 220 * (i / 40);
      fen.push(P([B1[0] + Math.SQRT1_2 * 34 + s * Math.SQRT1_2, 0, B1[2] + Math.SQRT1_2 * 34 - s * Math.SQRT1_2]));
    }
    ctx.beginPath();
    fen.filter(Boolean).forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
    ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 1.8; ctx.stroke();

    // baselines: home→first lit, the rest faint
    const line = (a, b, col, lw, dash) => {
      const pa = P(a), pb = P(b); if (!pa || !pb) return;
      ctx.beginPath(); ctx.moveTo(pa[0], pa[1]); ctx.lineTo(pb[0], pb[1]);
      ctx.strokeStyle = col; ctx.lineWidth = lw;
      if (dash) ctx.setLineDash(dash);
      ctx.stroke(); ctx.setLineDash([]);
    };
    line(HOME, B1, 'rgba(255,255,255,.46)', 2.6);
    // foul line carrying on past the bag
    line(B1, [B1[0] * 2.4, 0, B1[2] * 2.4], 'rgba(255,255,255,.24)', 1.8);
    // running lane chalk, 3 ft outside the line
    const off = [Math.SQRT1_2 * 3, 0, -Math.SQRT1_2 * 3];
    line([off[0], 0, off[2]], [B1[0] + off[0], 0, B1[2] + off[2]], 'rgba(255,255,255,.26)', 1.6, [7, 9]);

    // the line the runner covers, filled in behind him
    const pa = P(HOME), pb = P([B1[0] * ease, 0, B1[2] * ease]);
    if (pa && pb && u > 0) {
      ctx.beginPath(); ctx.moveTo(pa[0], pa[1]); ctx.lineTo(pb[0], pb[1]);
      ctx.strokeStyle = 'rgba(255,196,0,.42)'; ctx.lineWidth = 3; ctx.lineCap = 'round'; ctx.stroke();
      ctx.lineCap = 'butt';
    }

    // bases as slabs with a visible top face
    const base = (c, lit) => {
      const s = 1.6, y = 0.5;
      const top = [[c[0] - s, y, c[2] - s], [c[0] + s, y, c[2] - s], [c[0] + s, y, c[2] + s], [c[0] - s, y, c[2] + s]].map(P);
      const front = [[c[0] - s, y, c[2] + s], [c[0] + s, y, c[2] + s], [c[0] + s, 0, c[2] + s], [c[0] - s, 0, c[2] + s]].map(P);
      this._poly(ctx, front, lit ? 'rgba(255,196,0,.26)' : 'rgba(255,255,255,.10)', null);
      this._poly(ctx, top, lit ? 'rgba(255,196,0,.75)' : 'rgba(255,255,255,.40)', lit ? 'rgba(255,196,0,1)' : 'rgba(255,255,255,.60)', 1.6);
    };
    // home plate: pentagon, flat
    const hp = [[-0.85, 0.2, -0.85], [0.85, 0.2, -0.85], [0.85, 0.2, 0.4], [0, 0.2, 1.1], [-0.85, 0.2, 0.4]].map(P);
    this._poly(ctx, hp, 'rgba(255,255,255,.44)', 'rgba(255,255,255,.72)', 1.6);
    base(B1, done);

    // batter's box
    [[-3.4, -2.2], [3.4, -2.2]].forEach(([bx]) => {
      const q = [[bx - 2, 0.15, -3], [bx + 2, 0.15, -3], [bx + 2, 0.15, 3], [bx - 2, 0.15, 3]].map(P);
      this._poly(ctx, q, null, 'rgba(255,255,255,.22)', 1.4);
    });

    // what the clock reads: zero in the box, live down the line, holds the split at the bag
    const shown = done ? runDur : running ? secs - t0 : 0;

    // ───── IR-beam gates: one across the box, one across the bag ─────
    const perp = [Math.SQRT1_2, 0, -Math.SQRT1_2];
    const at = (s, side, y) => [D * s + perp[0] * side, y, D * s + perp[2] * side];
    const gates = [0.03, 1.0];
    gates.forEach((g, gi) => {
      const half = 5.5, top = 3.2;
      const broke = running && Math.abs(ease - g) < 0.032;
      const tripped = gi === 0 ? secs >= t0 : done;
      [1, -1].forEach(side => {
        const b = P(at(g, side * half, 0)), tp = P(at(g, side * half, top));
        if (!b || !tp) return;
        const sc = (b[1] - tp[1]) / top;
        ctx.strokeStyle = 'rgba(255,255,255,.30)';
        ctx.lineWidth = Math.max(1.4, sc * 0.09);
        ctx.beginPath(); ctx.moveTo(b[0], b[1]); ctx.lineTo(tp[0], tp[1]); ctx.stroke();
        [-1, 1].forEach(d => {
          ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = Math.max(1.1, sc * 0.06);
          ctx.beginPath(); ctx.moveTo(b[0], b[1] - sc * 0.12); ctx.lineTo(b[0] + d * sc * 0.7, b[1]); ctx.stroke();
        });
        const bw = sc * 0.72, bh = sc * 0.52;
        ctx.fillStyle = side > 0 ? 'rgba(255,196,0,.50)' : 'rgba(255,255,255,.14)';
        ctx.fillRect(tp[0] - bw / 2, tp[1] - bh, bw, bh);
        ctx.strokeStyle = side > 0 ? 'rgba(255,196,0,.85)' : 'rgba(255,255,255,.40)';
        ctx.lineWidth = 1.3; ctx.strokeRect(tp[0] - bw / 2, tp[1] - bh, bw, bh);
        if (side < 0) {
          ctx.beginPath(); ctx.arc(tp[0], tp[1] - bh / 2, Math.max(1.6, sc * 0.10), 0, Math.PI * 2);
          ctx.fillStyle = broke ? 'rgba(255,70,60,.95)' : tripped ? 'rgba(120,255,150,.55)' : 'rgba(255,70,60,.35)';
          ctx.fill();
        }
      });
      const ta = P(at(g, half, 2.9)), tb = P(at(g, -half, 2.9));
      if (ta && tb) {
        ctx.beginPath(); ctx.moveTo(ta[0], ta[1]); ctx.lineTo(tb[0], tb[1]);
        ctx.strokeStyle = broke ? 'rgba(255,106,43,.85)' : 'rgba(255,196,0,.32)';
        ctx.lineWidth = broke ? 3 : 1.8;
        if (broke) ctx.setLineDash([4, 6]);
        ctx.stroke(); ctx.setLineDash([]);
      }
    });

    // ───── the runner ─────
    const rw = [B1[0] * ease, 0, B1[2] * ease];
    // cadence ramps 1.3 → 2.3 gait cycles/sec, then holds
    const rs = Math.max(0, Math.min(runDur, secs - t0));
    const ramp = 1.3, c0 = 1.3, c1 = 2.3;
    const gp = rs <= ramp
      ? c0 * rs + (c1 - c0) * rs * rs / (2 * ramp)
      : c0 * ramp + (c1 - c0) * ramp / 2 + c1 * (rs - ramp);
    const gait = running ? ((gp % 1) + 1) % 1 : 0;
    // hips sit lowest at mid-stance, highest in flight — twice per cycle
    const bob = running ? (1 - Math.cos((gait - 0.17) * Math.PI * 4)) * 0.11 : 0;
    const hipH = 3.0 + bob;
    const hips = P([rw[0], hipH, rw[2]]);
    const feetP = P([rw[0], 0, rw[2]]);
    const headP = P([rw[0], 5.9, rw[2]]);
    if (hips && feetP && headP) {
      const px = hips[0], scale = (feetP[1] - headP[1]) / 5.9; // px per foot at this depth
      // ground shadow
      ctx.save();
      ctx.translate(feetP[0], feetP[1]);
      ctx.scale(1, 0.34);
      ctx.beginPath(); ctx.arc(0, 0, scale * 1.5, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(0,0,0,.30)'; ctx.fill();
      ctx.restore();

      // motion smear behind him
      if (running) {
        for (let k = 1; k <= 4; k++) {
          const e2 = Math.max(0, ease - k * 0.008);
          const q = P([B1[0] * e2, 3.0, B1[2] * e2]);
          if (!q) continue;
          ctx.beginPath(); ctx.arc(q[0], q[1], scale * 0.5, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255,196,0,' + ((1 - k / 4) * 0.045).toFixed(3) + ')'; ctx.fill();
        }
      }

      const ink = 'rgba(255,255,255,.95)', dim = 'rgba(255,255,255,.55)';
      const lw = Math.max(2.2, scale * 0.32);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = lw;
      const RAD = Math.PI / 180;
      // torso pitched well forward out of the box, easing to a normal sprint carriage
      const lean = (running ? (u < 0.25 ? 26 - u * 56 : 12) : 4) * RAD;
      const hipX = px, hipY = feetP[1] - hipH * scale;
      const thigh = 1.55 * scale, shank = 1.5 * scale, footL = 0.45 * scale, torso = 1.95 * scale;
      const shoX = hipX + Math.sin(lean) * torso, shoY = hipY - Math.cos(lean) * torso;
      const mix = (a, b, q) => a + (b - a) * q, ss = q => q * q * (3 - 2 * q);

      // sprint cycle, phase 0 = foot strike: 34% stance, then heel recovery, then knee drive
      const legAngles = p => {
        p = ((p % 1) + 1) % 1;
        let hip, knee;
        if (p < 0.34) {                       // stance: hip extends behind, knee gives then drives
          const q = ss(p / 0.34);
          hip = mix(24, -36, q); knee = mix(14, 10, q) + 12 * Math.sin(Math.PI * q);
        } else if (p < 0.62) {                // recovery: heel folds up under the hip
          const q = ss((p - 0.34) / 0.28);
          hip = mix(-36, 16, q); knee = mix(10, 112, q);
        } else {                              // knee drive, then the shin unfolds to strike
          const q = ss((p - 0.62) / 0.38);
          hip = mix(16, 24, q) + 20 * Math.sin(Math.PI * q); knee = mix(112, 16, q);
        }
        return { hip: hip * RAD, knee: knee * RAD };
      };
      const drawLeg = (p, col) => {
        const a = legAngles(p);
        const kx = hipX + Math.sin(a.hip) * thigh, ky = hipY + Math.cos(a.hip) * thigh;
        const sa = a.hip - a.knee;
        const fx2 = kx + Math.sin(sa) * shank;
        const fy2 = Math.min(ky + Math.cos(sa) * shank, feetP[1]);
        ctx.strokeStyle = col;
        ctx.beginPath(); ctx.moveTo(hipX, hipY); ctx.lineTo(kx, ky); ctx.lineTo(fx2, fy2); ctx.stroke();
        const planted = fy2 > feetP[1] - scale * 0.25;
        ctx.beginPath(); ctx.moveTo(fx2, fy2);
        ctx.lineTo(fx2 + footL, fy2 - (planted ? scale * 0.10 : scale * 0.30)); ctx.stroke();
      };
      const drawArm = (p, col) => {
        const q = ((p % 1) + 1) % 1;
        const sw = Math.sin(q * Math.PI * 2);
        const upper = 0.95 * scale, fore = 0.85 * scale;
        const sa = (34 * sw - 10) * RAD + lean;
        const ex = shoX + Math.sin(sa) * upper, ey = shoY + Math.cos(sa) * upper;
        const fa = sa + (26 + 78 * (sw + 1) / 2) * RAD;   // elbow stays bent; hand rises on the forward swing
        ctx.strokeStyle = col;
        ctx.beginPath(); ctx.moveTo(shoX, shoY); ctx.lineTo(ex, ey);
        ctx.lineTo(ex + Math.sin(fa) * fore, ey + Math.cos(fa) * fore); ctx.stroke();
      };

      drawLeg(gait + 0.5, dim);            // far side first
      drawArm(gait + 0.5, dim);            // each arm opposes the leg on its own side
      ctx.strokeStyle = ink;
      ctx.beginPath(); ctx.moveTo(hipX, hipY); ctx.lineTo(shoX, shoY); ctx.stroke();
      drawLeg(gait, ink);                  // near side on top
      drawArm(gait, ink);
      // head carried over the shoulders, tipped with the lean
      const hx = shoX + Math.sin(lean) * 0.62 * scale, hy = shoY - Math.cos(lean) * 0.62 * scale;
      ctx.beginPath(); ctx.arc(hx, hy, scale * 0.40, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,196,0,.9)'; ctx.fill();
    }

    // ───── scoreboard post beside the bag — nearest object in the shot, so it paints last ─────
    // as a section background it projects into the upper-left quadrant, over the hero copy
    const bpB = this.quiet ? null : P([B1[0] + perp[0] * 16, 0, B1[2] + perp[2] * 16]);
    const bpT = bpB && P([B1[0] + perp[0] * 16, 7.4, B1[2] + perp[2] * 16]);
    if (bpB && bpT) {
      const sc = (bpB[1] - bpT[1]) / 7.4;
      ctx.lineCap = 'butt';
      ctx.strokeStyle = 'rgba(255,255,255,.22)'; ctx.lineWidth = Math.max(1.5, sc * 0.11);
      ctx.beginPath(); ctx.moveTo(bpB[0], bpB[1]); ctx.lineTo(bpT[0], bpT[1]); ctx.stroke();
      const pw = sc * 4.4, ph = sc * 1.9, x0 = bpT[0] - pw / 2, y0 = bpT[1] - ph;
      ctx.fillStyle = 'rgba(16,19,24,.88)'; ctx.fillRect(x0, y0, pw, ph);
      ctx.strokeStyle = 'rgba(255,255,255,.28)'; ctx.lineWidth = 1.4; ctx.strokeRect(x0, y0, pw, ph);
      const dh = ph * 0.55, dw = dh * 0.5;
      this._segStr(ctx, x0 + ph * 0.24, y0 + ph * 0.23, dw, dh, shown.toFixed(2), 'rgba(255,196,0,.80)', 'rgba(255,255,255,.05)');
    }

    // clock: zero in the box, live down the line, holds the final at the bag
    const S = Math.min(w, h);
    this._readout(ctx, w * 0.70, h * 0.30, S * 0.115, shown.toFixed(2), 0.20, true);
    this._readout(ctx, w * 0.70, h * 0.86, S * 0.052, done ? '90 ft' : (ease * 90).toFixed(0) + ' ft', 0.13, false);
    this._readout(ctx, w * 0.70, h * 0.44, S * 0.044, done ? '1/1' : '0/1', 0.12, false);
    ctx.restore();
  }

  // ───────── seven-segment digits ─────────
  _seven(ctx, x, y, w, h, ch, on, off) {
    const map = { '0':'abcdef','1':'bc','2':'abged','3':'abgcd','4':'fgbc','5':'afgcd','6':'afgedc','7':'abc','8':'abcdefg','9':'abcdfg','-':'g',' ':'' };
    const lit = map[ch] || '';
    const t = Math.max(2, w * 0.20), m = t * 0.55, hh = h / 2;
    const S = {
      a: [x + m, y, w - t, t], g: [x + m, y + hh - t / 2, w - t, t], d: [x + m, y + h - t, w - t, t],
      f: [x, y + m, t, hh - t], b: [x + w - t, y + m, t, hh - t],
      e: [x, y + hh + m - t / 2, t, hh - t], c: [x + w - t, y + hh + m - t / 2, t, hh - t]
    };
    Object.keys(S).forEach(k => {
      const r = S[k], isOn = lit.indexOf(k) >= 0;
      ctx.fillStyle = isOn ? on : off;
      ctx.fillRect(r[0], r[1], r[2], r[3]);
    });
  }
  _segStr(ctx, x, y, dw, h, str, on, off) {
    const gap = dw * 0.28;
    let cx = x;
    for (const ch of str) {
      if (ch === '.' || ch === ':') {
        ctx.fillStyle = on;
        const s = Math.max(2, dw * 0.20);
        if (ch === '.') ctx.fillRect(cx, y + h - s, s, s);
        else { ctx.fillRect(cx, y + h * 0.28, s, s); ctx.fillRect(cx, y + h * 0.66, s, s); }
        cx += s + gap;
      } else {
        this._seven(ctx, cx, y, dw, h, ch, on, off);
        cx += dw + gap;
      }
    }
    return cx - x - gap;
  }

  // ───────── Loop D · IR-beam gates ─────────
  _drawBeam(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);
    const secs = t * 18;
    const laneTop = h * 0.30, laneBot = h * 0.74, laneMid = (laneTop + laneBot) / 2;
    const gates = [{ x: w * 0.22, dead: 4, hit: 3.2 }, { x: w * 0.78, dead: 6, hit: 12.6 }];

    // lane
    ctx.strokeStyle = 'rgba(255,255,255,.18)'; ctx.lineWidth = 1.8;
    [laneTop, laneBot].forEach(y => { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke(); });
    ctx.beginPath(); ctx.moveTo(0, laneMid); ctx.lineTo(w, laneMid);
    ctx.strokeStyle = 'rgba(255,255,255,.13)'; ctx.setLineDash([14, 16]); ctx.stroke(); ctx.setLineDash([]);

    // runner sweeps the lane, loops off-screen
    const rx = -w * 0.08 + (w * 1.16) * Math.min(1, secs / 16);
    const ry = laneMid + Math.sin(secs * 2.2) * S * 0.012;

    gates.forEach((G, gi) => {
      const broken = Math.abs(rx - G.x) < S * 0.018;
      const since = secs - G.hit;
      const arming = since > 0 && since < G.dead;
      const blink = arming && (Math.floor(since * 2) % 2 === 0);

      // beam
      ctx.beginPath(); ctx.moveTo(G.x, laneTop + S * 0.03); ctx.lineTo(G.x, laneBot - S * 0.03);
      if (broken) ctx.strokeStyle = 'rgba(255,106,43,.75)';
      else if (arming) ctx.strokeStyle = 'rgba(255,196,0,' + (blink ? .30 : .10) + ')';
      else ctx.strokeStyle = 'rgba(255,196,0,.34)';
      ctx.lineWidth = broken ? 3 : 1.8;
      ctx.setLineDash(broken ? [3, 5] : []); ctx.stroke(); ctx.setLineDash([]);

      if (broken) {
        const g = ctx.createRadialGradient(G.x, ry, 0, G.x, ry, S * 0.13);
        g.addColorStop(0, 'rgba(255,106,43,.40)'); g.addColorStop(1, 'rgba(255,106,43,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(G.x, ry, S * 0.13, 0, Math.PI * 2); ctx.fill();
      }

      // transmitter (yellow, top) and receiver (charcoal + LED, bottom), on tripods
      const bw = S * 0.042, bh = S * 0.030;
      const tx = G.x - bw / 2, ty = laneTop - bh - S * 0.012;
      ctx.fillStyle = 'rgba(255,196,0,.42)'; ctx.fillRect(tx, ty, bw, bh);
      ctx.strokeStyle = 'rgba(255,196,0,.7)'; ctx.lineWidth = 1.4; ctx.strokeRect(tx, ty, bw, bh);

      const ry2 = laneBot + S * 0.012;
      ctx.fillStyle = 'rgba(255,255,255,.10)'; ctx.fillRect(tx, ry2, bw, bh);
      ctx.strokeStyle = 'rgba(255,255,255,.28)'; ctx.strokeRect(tx, ry2, bw, bh);
      ctx.beginPath(); ctx.arc(G.x, ry2 + bh / 2, S * 0.006, 0, Math.PI * 2);
      ctx.fillStyle = broken || blink ? 'rgba(255,70,60,.9)' : 'rgba(255,70,60,.22)'; ctx.fill();

      // tripod legs
      [[-1, ty + bh], [1, ty + bh], [-1, ry2 + bh], [1, ry2 + bh]].forEach(([d, y0]) => {
        ctx.beginPath(); ctx.moveTo(G.x, y0); ctx.lineTo(G.x + d * S * 0.020, y0 + S * 0.030);
        ctx.strokeStyle = 'rgba(255,255,255,.13)'; ctx.lineWidth = 1.3; ctx.stroke();
      });

      // dead-time countdown beside the arming gate
      if (arming) this._readout(ctx, G.x + S * 0.035, ry2 + bh, S * 0.038, String(Math.ceil(G.dead - since)).padStart(2, '0'), 0.22, false);
      void gi;
    });

    // runner
    const gr = ctx.createRadialGradient(rx, ry, 0, rx, ry, 26);
    gr.addColorStop(0, 'rgba(255,196,0,.38)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(rx, ry, 26, 0, Math.PI * 2); ctx.fill();
    for (let k = 1; k < 14; k++) {
      const a = 1 - k / 14;
      ctx.beginPath(); ctx.arc(rx - k * S * 0.011, ry + Math.sin((secs - k * 0.05) * 2.2) * S * 0.012, 2.4, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,196,0,' + (a * 0.22).toFixed(3) + ')'; ctx.fill();
    }
    ctx.beginPath(); ctx.arc(rx, ry, 6, 0, Math.PI * 2);
    ctx.fillStyle = '#FFC400'; ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,.85)'; ctx.lineWidth = 1.7; ctx.stroke();

    // running clock: zero until gate 1, live between gates, held after gate 2
    const started = secs >= gates[0].hit, stopped = secs >= gates[1].hit;
    const elapsed = stopped ? gates[1].hit - gates[0].hit : started ? secs - gates[0].hit : 0;
    this._readout(ctx, w * 0.09, h * 0.19, S * 0.115, elapsed.toFixed(3), 0.20, true);
    this._readout(ctx, w * 0.62, h * 0.90, S * 0.052, stopped ? '9.400' : '0.000', 0.13, false);
    this._readout(ctx, w * 0.86, h * 0.20, S * 0.044, started ? (stopped ? '2/2' : '1/2') : '0/2', 0.12, false);
  }

  // ───────── Loop E · scoreboard mirror ─────────
  _drawBoard(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);
    const secs = t * 12;
    const live = secs % 12;
    const lag = Math.max(0, live - 0.22);
    const fmt = v => {
      const s = Math.floor(v), ms = Math.floor((v - s) * 1000);
      return String(s).padStart(2, '0') + '.' + String(ms).padStart(3, '0');
    };

    // big board panel — frame-scale digits collide with copy, so they're standalone-only
    const bw = w * 0.62, bh = S * 0.30, bx = w * 0.30, by = h * 0.34;
    ctx.fillStyle = 'rgba(255,255,255,.05)'; ctx.fillRect(bx, by, bw, bh);
    ctx.strokeStyle = 'rgba(255,255,255,.26)'; ctx.lineWidth = 2; ctx.strokeRect(bx, by, bw, bh);
    const dh = bh * 0.60, dw = dh * 0.50, pad = bh * 0.20;
    if (!this.quiet) this._segStr(ctx, bx + pad, by + pad, dw, dh, fmt(lag), 'rgba(255,196,0,.34)', 'rgba(255,255,255,.028)');

    // board legs
    [0.28, 0.72].forEach(u => {
      ctx.beginPath(); ctx.moveTo(bx + bw * u, by + bh); ctx.lineTo(bx + bw * u, by + bh + S * 0.10);
      ctx.strokeStyle = 'rgba(255,255,255,.22)'; ctx.lineWidth = 2.2; ctx.stroke();
    });

    // controller in the hand: small panel, lower left
    const cw = S * 0.17, ch = S * 0.085, cxp = w * 0.07, cyp = h * 0.60;
    ctx.fillStyle = 'rgba(255,255,255,.07)'; ctx.fillRect(cxp, cyp, cw, ch);
    ctx.strokeStyle = 'rgba(255,255,255,.34)'; ctx.lineWidth = 1.6; ctx.strokeRect(cxp, cyp, cw, ch);
    const sdh = ch * 0.52, sdw = sdh * 0.50;
    if (!this.quiet) this._segStr(ctx, cxp + ch * 0.22, cyp + ch * 0.24, sdw, sdh, fmt(live), 'rgba(255,196,0,.55)', 'rgba(255,255,255,.035)');

    // RF arcs from controller to board
    const ox = cxp + cw, oy = cyp + ch * 0.3;
    for (let k = 0; k < 4; k++) {
      const ph = (secs * 0.9 + k * 0.25) % 1;
      const r = S * (0.05 + ph * 0.42);
      ctx.beginPath(); ctx.arc(ox, oy, r, -Math.PI * 0.42, Math.PI * 0.16);
      ctx.strokeStyle = 'rgba(255,196,0,' + ((1 - ph) * 0.34).toFixed(3) + ')';
      ctx.lineWidth = 2; ctx.stroke();
    }

    // matching ID badge under each
    this._readout(ctx, cxp + cw * 0.05, cyp + ch + S * 0.045, S * 0.034, 'id 04', 0.14, false);
    this._readout(ctx, bx + bw * 0.02, by + bh + S * 0.075, S * 0.034, 'id 04', 0.12, false);
  }

  // ───────── Loop F · circuit intervals ─────────
  _drawCircuit(cv, t) {
    const f = this._fit(cv); if (!f) return;
    const { ctx, w, h } = f;
    const S = Math.min(w, h);
    const secs = t * 15;
    const work = 4, rest = 4, cycle = work + rest;
    const round = Math.floor(secs / cycle);
    const inCycle = secs % cycle;
    const isWork = inCycle < work;
    const left = isWork ? work - inCycle : cycle - inCycle;
    const frac = isWork ? left / work : left / rest;
    const hue = isWork ? '255,196,0' : '255,106,43';

    const cx = w * 0.50, cy = h * 0.44, r = S * 0.24;
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(255,255,255,.14)'; ctx.lineWidth = S * 0.022; ctx.stroke();
    const a0 = -Math.PI / 2;
    ctx.beginPath(); ctx.arc(cx, cy, r, a0, a0 + Math.PI * 2 * frac);
    ctx.strokeStyle = 'rgba(' + hue + ',.62)'; ctx.lineWidth = S * 0.022; ctx.lineCap = 'round'; ctx.stroke();
    ctx.lineCap = 'butt';

    // whole seconds in the middle, milliseconds running below (circ mode display)
    ctx.textAlign = 'center';
    ctx.font = '700 ' + (S * (this.quiet ? 0.11 : 0.20)) + "px 'Barlow Condensed', sans-serif";
    ctx.fillStyle = 'rgba(' + hue + ',.26)';
    ctx.fillText(String(Math.ceil(left)), cx, cy + S * 0.07);
    ctx.textAlign = 'left';
    this._readout(ctx, cx - S * 0.05, cy + S * 0.16, S * 0.045, String(Math.floor((1 - (left % 1)) * 1000)).padStart(3, '0'), 0.15, false);

    // completed rounds stack below
    const bars = 6, bw2 = S * 0.055, gap = S * 0.018;
    const totalW = bars * bw2 + (bars - 1) * gap;
    for (let i = 0; i < bars; i++) {
      const x = cx - totalW / 2 + i * (bw2 + gap), y = cy + r + S * 0.10;
      const done = i < round;
      ctx.fillStyle = done ? 'rgba(255,196,0,.50)' : 'rgba(255,255,255,.14)';
      ctx.fillRect(x, y, bw2, S * 0.012);
    }

    // faint pulse ring on each transition
    const sinceFlip = isWork ? inCycle : inCycle - work;
    if (sinceFlip < 0.6) {
      const k = 1 - sinceFlip / 0.6;
      ctx.beginPath(); ctx.arc(cx, cy, r + (1 - k) * S * 0.14, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(' + hue + ',' + (k * 0.22).toFixed(3) + ')'; ctx.lineWidth = 2; ctx.stroke();
    }

    this._readout(ctx, w * 0.10, h * 0.24, S * 0.070, (round + 1) + '/6', 0.14, true);
    this._readout(ctx, w * 0.82, h * 0.80, S * 0.048, isWork ? '04' : '04', 0.11, false);
  }
  }

  var engine = new Loops();
  engine.noClear = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t0 = performance.now();
  var items = [];
  var raf = 0;

  var FN = {
    diamond: '_drawDiamond', sport: '_drawSport', shoot: '_drawShoot', clocks: '_drawClocks',
    beam: '_drawBeam', board: '_drawBoard', circuit: '_drawCircuit'
  };

  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -160 && r.top < window.innerHeight + 160;
  }

  var SLOW = 1.9;    // stretch every loop's authored duration
  var GAP = 2.2;     // dark beat between clips
  var FADE = 0.7;    // cross-fade in/out of each clip
  var DIM = 0.62;    // overall ink level

  function buildReel(keys) {
    var reel = [], at = 0;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!DUR[k]) continue;
      var len = DUR[k] * SLOW;
      reel.push({ key: k, start: at, len: len });
      at += len + GAP;
    }
    return { clips: reel, total: at || 1 };
  }

  function tick() {
    var secs = (performance.now() - t0) / 1000;
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var r = it.host.getBoundingClientRect();
      if (r.bottom < -160 || r.top > vh + 160) continue;
      var p = Math.max(-1, Math.min(1, ((vh / 2) - (r.top + r.height / 2)) / ((vh + r.height) / 2)));
      it.inner.style.transform = 'translate3d(0,' + (p * r.height * 0.09).toFixed(1) + 'px,0)';
      if (!visible(it.cv)) continue;

      var reel = it.reel;
      var now = reduce ? reel.clips[0].len * 0.42 : (secs + it.offset) % reel.total;
      var clip = null;
      for (var c = 0; c < reel.clips.length; c++) {
        var cl = reel.clips[c];
        if (now >= cl.start && now < cl.start + cl.len) { clip = cl; break; }
      }
      var ctx = it.cv.getContext('2d');
      if (!clip) {                      // the waiting beat — hold an empty frame
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, it.cv.width, it.cv.height);
        continue;
      }
      var local = now - clip.start;
      var fade = Math.min(1, local / FADE, (clip.len - local) / FADE);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, it.cv.width, it.cv.height);
      ctx.save();
      ctx.globalAlpha = DIM * Math.max(0, fade);
      engine.quiet = it.quiet;
      engine[FN[clip.key]](it.cv, local / clip.len);
      ctx.restore();
    }
    raf = requestAnimationFrame(tick);
  }

  function init() {
    var hosts = document.querySelectorAll('[data-ssw-loop]');
    items = [];
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var keys = (host.getAttribute('data-ssw-loop') || '').split(',').map(function (s) { return s.trim(); });
      var reel = buildReel(keys);
      if (!reel.clips.length || host.querySelector('canvas')) continue;
      var inner = document.createElement('div');
      inner.className = 'ssw-loop-inner';
      var cv = document.createElement('canvas');
      cv.className = 'ssw-loop-canvas';
      inner.appendChild(cv);
      host.appendChild(inner);
      items.push({
        host: host, inner: inner, cv: cv, reel: reel,
        offset: parseFloat(host.getAttribute('data-ssw-loop-offset') || 0) || 0,
        quiet: !host.hasAttribute('data-ssw-loop-hud')
      });
    }
    if (raf) cancelAnimationFrame(raf);
    if (items.length) raf = requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
